import {marked} from "marked";
import DOMPurify from "dompurify";

marked.setOptions({breaks: true, gfm: true});

const DEFAULT_PURIFY_CONFIG = {USE_PROFILES: {html: true}};

export const renderUpToSafeBoundary = (text) => {
  if (!text) {
    return "";
  }

  const lastClosing = text.lastIndexOf(">");
  const lastOpening = text.lastIndexOf("<");
  if (lastOpening > lastClosing) {
    return text.substring(0, lastOpening);
  }

  const incompleteEntityAtEnd = /&[^;\s]*$/.test(text);
  if (incompleteEntityAtEnd) {
    return text.replace(/&[^;\s]*$/, "");
  }

  return text;
};

export const formatResponse = (response, isDarkTheme, isStreaming = false, purifyConfig) => {
  const safeResponse = isStreaming ? renderUpToSafeBoundary(response) : response;
  const sanitizedHtml = DOMPurify.sanitize(
    marked.parse(safeResponse),
    purifyConfig || DEFAULT_PURIFY_CONFIG,
  );
  const linkColor = isDarkTheme ? "#ADD8E6" : "#8dc1ef";
  return sanitizedHtml.replace(
    /<a /g,
    `<a style="color: ${linkColor};" target="_blank" rel="noopener noreferrer" `,
  );
};
